<div class="wrapper app-cover">
  <!-- <div class="sidebar" data-color="white" data-active-color="danger">
        <sidebar-cmp></sidebar-cmp>
    </div> -->
  <div class="main-panel">
    <navbar-cmp></navbar-cmp>
    <div class="content pt-4 pt-lg-5">
      <router-outlet></router-outlet>
      <!-- <footer-cmp></footer-cmp> -->
    </div>
  </div>
</div>
<!-- <fixedplugin-cmp></fixedplugin-cmp> -->
`
